module.exports = __webpack_public_path__ + "img/search-icon.9b51ba99.svg";